module.exports = "/_next/static/images/building-a823c8c9495ae377d55aea9dd3fe947e.jpg";